import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { EasmArtifactsInventoryDataProviderFactory } from '../factory/EasmArtifactsInventoryDataProviderFactory';
import { EasmArtifactsInventoryGridViewData } from '../types';
import { EasmArtifactsInventoryGridViewDataProvider } from '../dataProvider/EasmArtifactsInventoryViewDataProvider';

export class EasmArtifactsInventoryRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmArtifactsInventoryDataProviderFactory;
  public dataProvider: EasmArtifactsInventoryGridViewDataProvider;

  public constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new EasmArtifactsInventoryDataProviderFactory(),
    });
  }

  public getDataForView(): Promise<EasmArtifactsInventoryGridViewData> {
    return this.dataProvider.getDataForView();
  }
}
